var e, r;
function i() {
  return r || (r = 1, e = function(n, u) {
    return n.indexOf(u) !== -1;
  }), e;
}
export {
  i as __require
};
